export enum EType {
    Edit = 0,
    Detail = 1
}